module.exports = __webpack_public_path__ + "bb3ec16dc70e7cee9f580dc803d2b2c5.pdf";